import React from 'react'
import logo from '../logo-text.png'

const About = () => (
    <>
    <div className="level" style={{marginBottom: '-5%'}}>
        <div className="level-item">
            <img src={logo} alt="Logo" style={{width: 350, height: 350}}/>
        </div>
    </div>
            <div className="level-left">
            <h1 className="is-size-2">What is Clusterfy?</h1>
        </div>
        <h2>
            Clusterfy is a site that tries to help students better organize their material by using clustered learning
        </h2>
        <h2>Clustered learning is a technique in which you learn stuff in groups rather than all at once</h2>
        <h1 className="is-size-2">What tools do we provide on our site?</h1>
        <h2>We provide tools such as flashcards, a pomodoro timer, and a chat section (cause study isn't fun on your own sometimes)</h2>
        <h1 className="is-size-2">Why these tools?</h1>
        <h2>
        We feel that students have a lot to memorize. We try to provide tools that will help them accomplish this more effectively
        </h2>
        <h1 className="is-size-2">Why Clusterfy?</h1>
        <h2>At Clusterfy we aim to give you tools that you can use so you aren't just memorizing information for your next test</h2>
        <h2>We try to take the studying experience and help make it easier to collaborate and visualize</h2>
        <h1 className="is-size-2">Who are we?</h1>
        <h2>We at Clusterfy are students as well who felt the studying process can be improved</h2>
        </>
)

export default About